export default (function (filename) {
  if (filename.indexOf('.') < 0) return undefined;
  return ".".concat(filename.split('.').pop());
});